import React, { Component } from 'react';
import { path } from 'ramda';
import PropTypes from 'prop-types';

import { DateField } from 'components/common/fields/DateTimeFields';

export default class DocumentText extends Component {
    static propTypes = {
        info: PropTypes.object,
        body: PropTypes.oneOfType([
            PropTypes.string.isRequired,
            PropTypes.number.isRequired,
        ])
    };

    render() {
        const { body = '', info } = this.props;

        return (
            <div className="pre-wrap preview-paddings">
                {body}
                <br />
                <b>{path(['creatorName'], info)}</b> <DateField date={path(['date'], info)}/>
            </div>
        );
    }
}
